window.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('[data-header-sticky="true"]')) {
        document.getElementsByTagName("html")[0].classList.add("tpt-header-sticky-enabled");
    }
});

function getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

    if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
        event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    if (summary.closest("header-drawer, menu-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener("mousedown", (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        "focus",
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add("focused");
        },
        true,
    );
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());

    document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        if (this.closest("product-info") && !this.closest(".quickview-modal") && document.querySelector(".sticky-button-cart")) {
            const inputQtyValue = this.querySelector('[name="quantity"]').value;
            document.querySelector('.sticky-button-cart [name="quantity"]').value = inputQtyValue;
        }
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle("disabled", value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle("disabled", value >= max);
        }
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    };
}

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        // if (window.productGalleryType != 'grid') {
        // 	window.pauseAllMedia();
        // }

        window.pauseAllMedia();

        if (!this.getAttribute("loaded")) {
            const content = document.createElement("div");
            content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

            this.setAttribute("loaded", true);
            const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
            if (focus) deferredElement.focus();

            if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
                deferredElement.play();
            }
        }
    }
}

customElements.define("deferred-media", DeferredMedia);

function updateMeasurementData() {
    console.log("Update mesurement data");
    const defaultInputQty = document.querySelector('.product__info-container .tpt-product__buy-button input[name="id"]');
    const defaultPrice = document.querySelector(".product__info-container .price-main");
    const measurementInputId = document.querySelector('.tpt-measurement__confirm-wrapper input[name="id"]');
    const measurementPrice = document.querySelectorAll(".tpt-measurement__info-product-price");

    if (measurementInputId) {
        measurementInputId.value = defaultInputQty.value;
    }

    if (measurementPrice) {
        measurementPrice.forEach((priceItem) => {
            priceItem.innerHTML = defaultPrice.innerHTML;
        });
    }
}

updateMeasurementData();

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);

        document.querySelectorAll("variant-selects fieldset").forEach((fieldset) => {
            const activeValue = fieldset.querySelector("[checked]").getAttribute("value");
            const titleHtml = '<span class="title-swatch-color">' + activeValue + "</span>";

            const fieldsetElement = fieldset.querySelector(".form__label");

            if (fieldsetElement.querySelector(".title-swatch-color")) {
                fieldsetElement.querySelector(".title-swatch-color").remove();
            }

            fieldsetElement.insertAdjacentHTML("beforeend", titleHtml);
        });
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select, fieldset"), (element) => {
            if (element.tagName === "SELECT") {
                console.log("VALUE...", element.value);
                return element.value;
            }
            if (element.tagName === "FIELDSET") {
                return Array.from(element.querySelectorAll("input")).find((radio) => radio.checked)?.value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateSelectedSwatchValue({ target }) {
        const { name, value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
            const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
            const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
            if (!selectedDropdownSwatchValue) return;
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue);
                selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
            } else {
                selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset");
                selectedDropdownSwatchValue.classList.add("swatch--unavailable");
            }
        } else if (tagName === "INPUT" && target.type === "radio") {
            const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }

        /**
         * Update title value selection variant
         */

        const titleHtml = '<span class="title-swatch-color">' + target.getAttribute("value") + "</span>";
        if (target.closest("fieldset")) {
            const variantLabel = target.closest("fieldset").querySelector(".form__label");

            if (variantLabel.querySelector(".title-swatch-color")) {
                variantLabel.querySelector(".title-swatch-color").remove();
            }

            variantLabel.insertAdjacentHTML("beforeend", titleHtml);
        }
    }

    updateMedia() {}

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        var productForms;

        productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
        const inputWrappers = [...this.querySelectorAll(".product-form__input")];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
            const value = element.getAttribute("value");
            const availableElement = availableValuesList.includes(value);

            if (element.tagName === "INPUT") {
                element.classList.toggle("disabled", !availableElement);
            } else if (element.tagName === "OPTION") {
                element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace("[value]", value);
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, "text/html");

                /**
                 * Update product media gallery
                 */
                if (this.closest(".shopify-section")) {
                    const gallaryProductContainer = this.closest(".shopify-section").querySelector(".tpt-product-media-gallery");

                    if (gallaryProductContainer) {
                        const mediaProductGallery = html.getElementById("ProductMediaGallery").innerHTML;

                        gallaryProductContainer.innerHTML = mediaProductGallery;
                    }
                }

                /**
                 * Update product media gallery in quickview modal
                 */
                if (this.closest(".quickview-modal")) {
                    const gallaryProductContainer = this.closest(".quickview-modal").querySelector(".tpt-product-media-gallery");

                    if (gallaryProductContainer) {
                        const mediaProductGallery = html.getElementById("ProductMediaGallery").innerHTML;

                        gallaryProductContainer.innerHTML = mediaProductGallery;
                    }
                }

                /**
                 * end update product media gallery
                 */

                var destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                const volumePricingSource = html.getElementById(`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

                const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
                const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

                const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
                const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
                const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

                if (volumeNote) volumeNote.classList.remove("hidden");
                if (volumePricingDestination) volumePricingDestination.classList.remove("hidden");
                if (qtyRules) qtyRules.classList.remove("hidden");

                /**
                 * Update price in modal quickview
                 */
                if (this.closest(".quickview-modal")) {
                    if (this.closest(".quickview-modal").querySelector(".price-main")) {
                        destination = this.closest(".quickview-modal").querySelector(".price-main");
                    }
                }

                if (source && destination) destination.innerHTML = source.innerHTML;

                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle("hidden", skuSource.classList.contains("hidden"));
                }

                if (volumePricingSource && volumePricingDestination) {
                    volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
                }

                if (pricePerItemSource && pricePerItemDestination) {
                    pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                    pricePerItemDestination.classList.toggle("hidden", pricePerItemSource.classList.contains("hidden"));
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove("hidden");

                if (inventoryDestination) inventoryDestination.classList.toggle("hidden", inventorySource.innerText === "");

                var addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

                this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true, window.variantStrings.soldOut);

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });

                if (document.querySelector(".sticky-button-cart") && !this.closest(".quickview-modal")) {
                    const newPriceHtml = document.querySelector('product-info [id^="price-template-"]').innerHTML;
                    const isDisabled = document.querySelector("product-info .product-form__submit").getAttribute("disabled");
                    const buttonAddCartText = document.querySelector("product-info .product-form__submit span").innerHTML;
                    const stickyButtonAddCart = document.querySelector(".sticky-button-cart .sticky-add-cart");

                    document.querySelector(".sticky-button-cart .sticky-add-cart .button-text").innerHTML = buttonAddCartText;

                    if (isDisabled == "disabled") {
                        stickyButtonAddCart.setAttribute("disabled", "disabled");
                    } else {
                        stickyButtonAddCart.removeAttribute("disabled");
                    }

                    document.querySelector(".sticky-button-cart .sticky-product_price").innerHTML = newPriceHtml;
                }

                updateMeasurementData();
            });

        updateStickyCartLabel();
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        var productForm = document.getElementById(`product-form-${this.dataset.section}`);

        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("hidden");
        if (inventory) inventory.classList.add("hidden");
        if (sku) sku.classList.add("hidden");
        if (pricePerItem) pricePerItem.classList.add("hidden");
        if (volumeNote) volumeNote.classList.add("hidden");
        if (volumeTable) volumeTable.classList.add("hidden");
        if (qtyRules) qtyRules.classList.add("hidden");
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: "0px 0px 400px 0px",
        }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);
/**
 * Product card variant picker
 */

if (!customElements.get("tpt-card-product-variant")) {
    customElements.define(
        "tpt-card-product-variant",
        class TptCardProductVariant extends HTMLElement {
            constructor() {
                super();

                this.toggleButton = this.querySelector("tpt-variant-toggle");
                this.cardProduct = this.closest(".product-card-wrapper");
                this.cardProductVariant = this.cardProduct.querySelector(".card-wrapper__variant-data");

                this.toggleButton.addEventListener("click", this.showProductVariant.bind(this));
                this.toggleButton.addEventListener("keypress", this.keyPress.bind(this));
            }

            keyPress(e) {
                if (e.key === "Enter") {
                    this.showProductVariant();
                }
            }

            showProductVariant() {
                const popupContent = this.cardProduct.querySelector(".card-wrapper__variant-content");

                if (this.cardProduct.classList.contains("loaded-variant")) {
                    this.cardProduct.classList.add("show-variant");
                    trapFocus(popupContent, popupContent);
                } else {
                    this.cardProduct.classList.add("loading-variant");
                    const productUrl = this.toggleButton.getAttribute("data-product-url");

                    fetch(productUrl)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
                            const variantData = responseHTML.querySelector(".shopify-section").innerHTML;
                            this.cardProductVariant.innerHTML = variantData;
                        })
                        .finally(() => {
                            this.cardProduct.classList.add("show-variant");
                            this.cardProduct.classList.add("loaded-variant");

                            const cardProduct = this.cardProduct;
                            setTimeout(() => {
                                cardProduct.classList.remove("loading-variant");
                                trapFocus(popupContent, popupContent);
                            }, 500);
                        });
                }
            }
        },
    );
}

/**
 * Close card product variant
 */

if (!customElements.get("tpt-close-variant")) {
    customElements.define(
        "tpt-close-variant",
        class TptCloseVariant extends HTMLElement {
            constructor() {
                super();

                this.cardProduct = this.closest(".product-card-wrapper");
                this.addEventListener("click", this.closeCardProductVariant.bind(this));
                this.addEventListener("keypress", this.keyPress.bind(this));
            }

            keyPress(e) {
                if (e.key === "Enter") {
                    this.closeCardProductVariant();
                }
            }

            closeCardProductVariant() {
                this.cardProduct.classList.remove("show-variant");
            }
        },
    );
}

/**
 * Card product variant picker
 */

class TptCardProductVariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange(event) {
        this.classList.add("loading");
        this.updateOptions();
        this.updateMasterId();
        this.removeErrorMessage();
        this.renderProductInfo();
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select, fieldset"), (element) => {
            if (element.tagName === "SELECT") {
                return element.value;
            }
            if (element.tagName === "FIELDSET") {
                return Array.from(element.querySelectorAll("input")).find((radio) => radio.checked)?.value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, "text/html");

                /**
                 * Update product variant id
                 */

                const inputIdForm = document.querySelectorAll('.tpt-card-product-variant__button input[name="id"]');
                inputIdForm.forEach((input) => {
                    input.value = this.currentVariant.id;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                });

                /**
                 * Update element class
                 */
                const productCardElement = this.closest(".product-card-wrapper");
                const elementUpdate = [".card-wrapper__variant-wrapper"];

                elementUpdate.forEach((element) => {
                    if (productCardElement.querySelector(element)) {
                        const elementHtml = html.querySelector(element).innerHTML;
                        productCardElement.querySelector(element).innerHTML = elementHtml;
                    }
                });

                this.classList.remove("loading");

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define("tpt-card-product-variant-selects", TptCardProductVariantSelects);

/**
 * Card product color variant
 */

/* get Featured image by color from variants source */
function getItemVariantByColor(variants, color) {
    const item = variants.find((v) => v.featured_image && (v.option1 === color || v.option2 === color || v.option3 === color));

    return item ? item : null;
}

class TptCardProductColorVariant extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.wrapperImage = this.closest(".product-card-wrapper").querySelector(".card__inner-image .ratio-content");

        this.addEventListener("change", this.colorSelected.bind(this));
    }

    colorSelected() {
        const checkedInput = this.querySelector("input:checked");
        if (!checkedInput) return;

        const colorValue = checkedInput.value;
        const variants = this.variants;

        const itemHasFeatureImage = getItemVariantByColor(variants, colorValue);

        if (itemHasFeatureImage) {
            const image = `<img class="image-swatches" src="${itemHasFeatureImage.featured_image.src}" alt="${colorValue}" width="600" height="600" />`;

            const imageSwatches = this.wrapperImage.querySelector("img.image-swatches");

            if (imageSwatches) {
                imageSwatches.src = itemHasFeatureImage.featured_image.src;
            } else {
                this.wrapperImage.insertAdjacentHTML("beforeend", image);
            }
        }
    }
}

customElements.define("tpt-card-product-color-variant", TptCardProductColorVariant);
/**
 * Card product creative
 */

if (!customElements.get("tpt-card-product-creative")) {
    customElements.define(
        "tpt-card-product-creative",
        class TptCardProductCreative extends HTMLElement {
            constructor() {
                super();

                this.addEventListener("mouseover", this.showCardProductCreative.bind(this));
                this.cardProduct = this.closest(".product-card-wrapper");
                this.cardProductCreative = this.cardProduct.querySelector(".tpt-card-product__creative-wrapper");
            }

            showCardProductCreative() {
                const productUrl = this.getAttribute("data-product-url");

                if (!this.cardProduct.classList.contains("loaded-creative") && !this.cardProduct.classList.contains("loading-creative")) {
                    this.cardProduct.classList.add("loading-creative");

                    fetch(productUrl)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
                            const creativeData = responseHTML.querySelector(".shopify-section").innerHTML;
                            this.cardProductCreative.innerHTML = creativeData;

                            /**
                             * Re-render javascript tags
                             */
                            this.cardProductCreative.querySelectorAll("script").forEach((oldScriptTag) => {
                                const newScriptTag = document.createElement("script");
                                Array.from(oldScriptTag.attributes).forEach((attribute) => {
                                    newScriptTag.setAttribute(attribute.name, attribute.value);
                                });
                                newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                                oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                            });
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.cardProduct.classList.add("loaded-creative");
                                this.cardProduct.classList.remove("loading-creative");
                            }, 100);
                        });
                }
            }
        },
    );
}

/**
 * Card product creative gallery
 */

if (!customElements.get("tpt-creative-gallery")) {
    customElements.define(
        "tpt-creative-gallery",
        class TptCreativeGallery extends HTMLElement {
            constructor() {
                super();

                const galleryContainer = this;
                const mainSwiper = this.querySelector(".tpt-creative__gallery-main .swiper");
                const mainNext = this.querySelector(".tpt-creative__gallery-main .swiper-button-next");
                const mainPrev = this.querySelector(".tpt-creative__gallery-main .swiper-button-prev");

                const thumbSwiper = this.querySelector(".tpt-creative__gallery-thumb .swiper");
                const thumbNext = this.querySelector(".tpt-creative__gallery-thumb .swiper-button-next");
                const thumbPrev = this.querySelector(".tpt-creative__gallery-thumb .swiper-button-prev");

                var swiperThumb = new Swiper(thumbSwiper, {
                    spaceBetween: 5,
                    autoHeight: false,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: thumbNext,
                        prevEl: thumbPrev,
                    },
                    keyboard: {
                        enabled: true,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 7,
                        },
                        768: {
                            slidesPerView: 7,
                        },
                    },
                });

                var swiperMain = new Swiper(mainSwiper, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    autoHeight: false,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: mainNext,
                        prevEl: mainPrev,
                    },
                    keyboard: {
                        enabled: true,
                    },
                    thumbs: {
                        swiper: swiperThumb,
                    },
                });

                swiperMain.on("transitionEnd", function () {
                    window.pauseAllMedia();

                    if (mainSwiper.querySelector(".swiper-slide-active")) {
                        const slideMediaType = mainSwiper.querySelector(".swiper-slide-active").getAttribute("data-media-type");

                        if (slideMediaType == "video" || slideMediaType == "model") {
                            galleryContainer.classList.add("hidden-lightbox");
                            swiperMain.allowTouchMove = false;
                        } else {
                            galleryContainer.classList.remove("hidden-lightbox");
                            swiperMain.allowTouchMove = true;
                        }
                    }
                });
            }
        },
    );
}
